<template>
    <div class="page-container">
        <!-- <van-search
            v-model="searchKey"
            show-action
            placeholder="名称、手机"
            @search="onSearch"
            @focus="onFocus"
            >
            <template #action>
                <div class="btn-search" @click="onSearch">搜索</div>
            </template>
        </van-search> -->
        <!-- 搜索栏 -->
        <div class="search-line">
            <div class="search-box">
                <img src="../assets/icon-search.png" alt="">
                <input type="text" v-model="searchKey" @focus="onFocus" placeholder="名称、手机"/>
            </div>
            <div class="btn-search" v-if="!hasSearch" @click="onSearch">搜索</div>
            <div class="btn-search" v-else @click="onCancel">取消</div>
        </div>
        <div class="address-list" v-if="list.length > 0">
            <div class="address-item" v-for="(item,index) in list" :key="index" @click="jumpDetail(item.id)">
                <div class="pic-name-wrapper">
                    <img :src="item.url" class="user-pic" />
                    <div class="address-info">
                        <div class="name-phone">{{item.name}}  {{item.mobile}}</div>
                        <div class="address-detail">{{`${item.province} ${item.city} ${item.county} ${item.address}`}}</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 无记录 -->
        <van-empty v-else :image=nullImg description="暂无数据~" />

        <div class="btn-confirm" @click="jumpAddressadd">
            <van-icon name="plus" size="14" color="#fff" />
            <span>新增客户</span>
        </div>
        <!-- 搜索框聚焦后的弹层 -->
        <div class="search-layer" :hidden="!showHistoryLayer">
            <div class="search-layer-title">
                <span>搜索历史</span>
                <van-icon name="delete" size="22" @click="removeHistory" />
            </div>
            <div class="search-history-list">
                <div class="search-history-item" v-for="(item,index) in searchHistoryList" :key="index">{{item}}</div>
            </div>
        </div>
    </div>
</template>
<script>
import { Search,Icon,Toast,Empty } from 'vant'

import $http from '@/lib/request'
import config from '@/config'
import { saveSearchHostory,getSearchHistory,clearSearchHistory } from '@/lib/util'

export default {
    data(){
        return {
            searchKey:'',
            showHistoryLayer:false,
            pageData:{},//页面数据
            list:[],//地址列表
            searchHistoryList:[],//搜索历史
            nullImg:require('@/assets/icon-null.png'),
            hasSearch:false,//是否已经搜索过
        }
    },
    components:{
        [Search.name]:Search,
        [Icon.name]:Icon,
        [Toast.name]:Toast,
        [Empty.name]:Empty
    },
    activated(){
        this.getData();
        this.searchHistoryList=getSearchHistory;
    },
    methods:{
        onSearch(){
            this.showHistoryLayer=false;
            this.getData();
            saveSearchHostory(this.searchKey);
            this.hasSearch=true;
        },
        onCancel(){
            this.hasSearch=false;
            this.searchKey='';
            this.getData();
        },
        removeHistory(){
            clearSearchHistory();
        },
        onFocus(){
            // this.showHistoryLayer=true;
        },
        jumpAddressadd(){
            this.$router.push({
                name:'address-add'
            });
        },
        getData(){
            $http({
                method:'post',
                data:{
                    name:this.searchKey
                },
                url:config.api.addressList
            }).then(res=>{
                if(res.errno == 0){
                    this.pageData=res.data;
                    this.list=res.data.list;
                }else{
                    Toast(res.errmsg);
                }
            })
        },
        jumpDetail(id){
            this.$router.push({
                name:'address-add',
                params:{
                    id:id
                }
            });
        }
    }
}
</script>
<style lang="scss" scoped>
::v-deep .van-empty__image{
    width:140px;
    height:108px;
}
::v-deep .van-empty{
    margin-top: 50px;
}
.van-search{
    height:46px!important;
}
.van-search__content{
    @media screen and (max-width:750px){
        border-radius: 10px;
    }
}
@mixin flex-between{
    display: flex;
    justify-content: space-around;
    align-items: center;
}
.page-container{
    min-height:calc(100vh - 46px);
    box-sizing: border-box;
    padding-bottom: 70px;
    background:#fafafa;
    .search-line{
        background:#fff;
        box-sizing: border-box;
        line-height:35px;
        padding:10px 8px;
        @include flex-between();
        .search-box{
            width: 300px;
            height: 36px;
            background: rgba(142, 142, 147, 0.12);
            border-radius: 10px;
            box-sizing: border-box;
            padding:0 15px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            &>img{
                width:22px;
                height:22px;
                margin-right: 5px;
            }
            &>input{
                height:22px;
                border:none;
                background:none;
                font-size: 14px;
                width: 240px;
                margin:0;
                padding:0;
                line-height: 22px;
            }
        }
        .btn-search{
            color:#3088F5;
            font-size: 17px;
        }
    }
    .address-list{
        padding:10px;
        .address-item{
            background:#fff;
            border-radius: 4px;
            box-sizing: border-box;
            padding:20px 15px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 10px;
            .pic-name-wrapper{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                .user-pic{
                    width:56px;
                    height:56px;
                    border-radius: 50%;
                    margin-right: 10px;
                }
                .address-info{
                    width: 250px;
                    color:#333;
                    line-height: 20px;
                    .name-phone{
                        margin-bottom: 4px;
                        font-size: 14px;
                    }
                    .address-detail{
                        color:#666;
                        line-height: 18px;
                        font-size: 14px;
                    }
                }
            }
        }
    }
    .btn-confirm{
        width: 180px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        background: linear-gradient(90deg, #3088F5 0%, #3CA7FE 100%);
        font-size: 14px;
        color:#fff;
        position: fixed;
        bottom:96px;
        left:50%;
        transform: translateX(-50%);
        display: flex;
        justify-content: center;
        align-items: center;
        @media screen and (max-width:750px){
            border-radius: 26px;
        }
        &>span{
            margin-left: 5px;
        }
    }
    .search-layer{
        height:calc(100vh - 46px);
        background:#fff;
        position: absolute;
        left:0;
        top:46px;
        z-index: 9;
        width:100%;
        box-sizing: border-box;
        padding:20px 15px;
        .search-layer-title{
            font-size: 14px;
            color:#333;
            display: flex;
            justify-content: space-between;
            align-items: center;

        }
        .search-history-list{
            padding:10px 0;
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            .search-history-item{
                padding:0 12px;
                height:26px;
                line-height: 26px;
                background:#f8f8f8;
                font-size: 12px;
                color:#666;
                margin-right: 10px;
                margin-bottom: 10px;
                @media screen and (max-width: 750px){
                    border-radius: 26px;
                }
            }
        }
    }
}
</style>